export const colorPalettes = {
    v1: {
      '--primary-color': '#01579B',
      '--action-color-light':'#0277BD',
      '--primary-color-dark': '#0277BD',
      '--principal-color': '#42a5f5',
      '--success-color': '#109618',
      '--error-color': '#DC3912',
      '--warn-color': '#FF9900',
      '--background': '#fff',
      '--card-background': '#fafafa',
      '--typo': '#37474F',
      '--secondary': '#fbfbfb',
      '--header': '#0d47a11f',
      '--scroll-background': '#eceff2',
      '--dark-background': '#011223',
      '--dark-card-background': '#131c29',
      '--dark-typo': '#fff',
      '--dark-buttons': '#2e2e3b',
      '--disable-buttons': '#0000001f',
      '--dark-secondary': '#1a222dfa',
      '--dark-header': '#42a5f51c',
      '--dark-scroll-background': '#0d131c',
      '--tooltip-light-background': '#c0c7cf',
      '--tooltip-dark-background': '#1b2d4a',
      '--snackbar-background': '#37374b',
      '--chart-primary': '#3366CC',
      '--chart-second': '#DC3912',
      '--chart-third': '#FF9900',
      '--chart-fourth': '#109618',
      '--chart-fifth': '#990099',
      '--chart-sixth': '#0099C6',
      '--chart-seventh': '#DD4477',
      '--chart-eighth': '#66AA00',
      '--chart-nineth': '#E67300',
      '--chart-tenth': '#CCCCCC',
      '--gray-color0': '#797979',
      '--gray-color1': '#CCCCCC',
      '--gray-color2': '#cac6c6',
      '--gray-color3': '#f3f3f3',
      '--gray-color4': '#e7e7e7a1',
      '--primary-hover': '#324ad5',
      '--toolbar-icons': '#6fc5ff40',
      '--primary-disabled': '#2196f35c',
      '--action-dark': '#202531',
      '--action-light': '#cbd8e5',
      '--secundary-dark-hover': '#424250',
      '--secondary-light-hover': '#eeeef9',
      '--warn-hover': '#f7695f',
      '--accent-hover': '#fdaf3d',
      '--disabled-hover': '#ffffff1f',
      '--strocket-hover': '#6e7dff3d',
      '--button-disabled-dark': '#ffffff4d',
      '--button-disabled-light': '#00000042',
      '--card-dark-border': '#2d3135',
      '--card-light-border': '#c3d6df',
      '--panel-dark-background': '#2a2a2a',
      '--panel-dark-expansion': '#303031',
      '--panel-dark-body': '#1a1a20',
      '--panel-light-background': '#F4F7FA',
      '--panel-light-expansion': '#9dacff4d',
      '--panel-light-body': '#fbfbfb',
      '--stepper-dark-header': '#242425',
      '--stepper-light-header': '#F4F7FA',
      '--stepper-light-content': '#EAEDF0',
      '--disable-dark-button': '#42425030',
      '--disable-dark-button-color': '#525252',
      '--disable-light-back': '#f0efff',
      '--disable-light-color': '#8284a361',
      '--disable-light-primary-bg': '#2196f35c',
      '--disable-light-primary': 'white',
      '--disable-dark-primary-bg': '#2196f35c',
      '--disable-dark-primary': '#ffffff47',
      '--selection-light-control': '#274f6496',
      '--selection-dark-control': '#d1d1df96',
      '--select-primary-checked': '#2196f39e',
      
    },
    v2: {      
        '--primary-color': '#7E57C2',
        '--action-color-light':'#7E57C2',
        '--primary-color-dark': '#be9cfa',
        '--principal-color': '#5E35B1',
        '--success-color': '#109618',
        '--error-color': '#DC3912',
        '--warn-color': '#FF9900',
        '--background': '#fff',
        '--card-background': '#fafafa',
        '--typo': '#37474F',
        '--secondary': '#fbfbfb',
        '--header': '#0d47a11f',
        '--scroll-background': '#eceff2',
        '--dark-background': '#011223',
        '--dark-card-background': '#131c29',
        '--dark-typo': '#fff',
        '--dark-buttons': '#2e2e3b',
        '--disable-buttons': '#0000001f',
        '--dark-secondary': '#1a222dfa',
        '--dark-header': '#42a5f51c',
        '--dark-scroll-background': '#0d131c',
        '--tooltip-light-background': '#c0c7cf',
        '--tooltip-dark-background': '#1b2d4a',
        '--snackbar-background': '#37374b',
        '--chart-primary': '#3366CC',
        '--chart-second': '#DC3912',
        '--chart-third': '#FF9900',
        '--chart-fourth': '#109618',
        '--chart-fifth': '#990099',
        '--chart-sixth': '#0099C6',
        '--chart-seventh': '#DD4477',
        '--chart-eighth': '#66AA00',
        '--chart-nineth': '#E67300',
        '--chart-tenth': '#CCCCCC',
        '--gray-color0': '#797979',
        '--gray-color1': '#CCCCCC',
        '--gray-color2': '#cac6c6',
        '--gray-color3': '#f3f3f3',
        '--gray-color4': '#e7e7e7a1',
        '--primary-hover': '#324ad5',
        '--toolbar-icons': '#6fc5ff40',
        '--primary-disabled': '#2196f35c',
        '--action-dark': '#202531',
        '--action-light': '#cbd8e5',
        '--secundary-dark-hover': '#303046',
        '--secondary-light-hover': '#eeeef9',
        '--warn-hover': '#f7695f',
        '--accent-hover': '#fdaf3d',
        '--disabled-hover': '#ffffff1f',
        '--strocket-hover': '#6e7dff3d',
        '--button-disabled-dark': '#ffffff4d',
        '--button-disabled-light': '#00000042',
        '--card-dark-border': '#2d3135',
        '--card-light-border': '#c3d6df',
        '--panel-dark-background': '#2a2a2a',
        '--panel-dark-expansion': '#303031',
        '--panel-dark-body': '#1a1a20',
        '--panel-light-background': '#F4F7FA',
        '--panel-light-expansion': '#9dacff4d',
        '--panel-light-body': '#fbfbfb',
        '--stepper-dark-header': '#242425',
        '--stepper-light-header': '#F4F7FA',
        '--stepper-light-content': '#EAEDF0',
        '--disable-dark-button': '#42425030',
        '--disable-dark-button-color': '#525252',
        '--disable-light-back': '#f0efff',
        '--disable-light-color': '#8284a361',
        '--disable-light-primary-bg': '#2196f35c',
        '--disable-light-primary': 'white',
        '--disable-dark-primary-bg': '#2196f35c',
        '--disable-dark-primary': '#ffffff47',
        '--selection-light-control': '#274f6496',
        '--selection-dark-control': '#d1d1df12',
        '--select-primary-checked': '#2196f39e',
        '--hight-light-color': '#311b92',
        '--hight-dark-color': '#7E57C2',
        '--low-dark-border': '#80808070',
        '--low-dark-border-2': '#e0e0e07d',
        '--form-error':'#f44336',
        '--info-light-background': 'rgb(19, 16, 79)',
        '--info-dark-background': '#311b92',

        }
  };
  